import { Link } from 'react-router';

import { BrandLogo } from '@/components/brand/BrandLogo';
import { brand } from '@/config/brand';
import { ROUTES } from '@/config/routes';

const LEGAL_LINKS = [
  { label: '이용약관', to: ROUTES.legal.terms },
  { label: '환불규정', to: ROUTES.legal.refund },
  { label: '개인정보처리방침', to: ROUTES.legal.privacy },
  { label: '사업자정보', to: ROUTES.legal.business },
] as const;

const BIZ_ITEMS = [
  { label: '상호명', value: brand.legal.company },
  { label: '대표자', value: brand.legal.ceo },
  { label: '사업자등록번호', value: brand.legal.bizNo },
  { label: '통신판매업신고번호', value: brand.legal.bizReportNo },
  { label: '주소', value: brand.legal.address },
] as const;

const LINK = 'transition-colors hover:text-foreground';

/**
 * FO 전역 푸터 — 반전 표면: 요소에 `dark` 를 붙여 Stillwater 다크 토큰(무대·글자)을 이 영역에만 적용한다
 * (푸터 전용 색 토큰을 두지 않는다). 브랜드 락업 + 법률 링크 + 고객센터 + 사업자 정보.
 */
export function FoFooter() {
  const telHref = `tel:${brand.legal.tel.replace(/[^0-9+]/g, '')}`;
  const mailHref = `mailto:${brand.legal.email}`;
  return (
    <footer className="dark bg-background text-sm text-muted-foreground">
      <div className="mx-auto max-w-content px-4 py-10 sm:px-gutter">
        <div className="flex flex-wrap items-start justify-between gap-6">
          <div className="max-w-xs text-foreground">
            <BrandLogo variant="mono" />
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{brand.tagline}</p>
          </div>
          <nav className="flex flex-wrap gap-6" aria-label="법적 고지">
            {LEGAL_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className={`font-medium ${LINK}`}>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-7 border-t pt-6">
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
            <span className="font-semibold text-foreground">고객센터</span>
            <a href={telHref} className={`text-base font-semibold ${LINK}`}>
              {brand.legal.tel}
            </a>
            {brand.legal.email && (
              <a href={mailHref} className={LINK}>
                {brand.legal.email}
              </a>
            )}
          </div>
          <dl className="mt-2 flex flex-wrap gap-x-5 gap-y-1 leading-relaxed">
            {brand.support.hoursItems.map((item) => (
              <div key={item.label} className="inline-flex items-baseline gap-1.5">
                <dt className="font-medium">{item.label}</dt>
                <dd className="">{item.value}</dd>
              </div>
            ))}
          </dl>
          <dl className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs leading-relaxed">
            {BIZ_ITEMS.map((item) => (
              <div key={item.label} className="inline-flex items-baseline gap-1.5">
                <dt className="font-medium">{item.label}</dt>
                <dd className="">{item.value}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-5 text-xs">{brand.legal.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
